import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ADMIN_LOGIN } from "../lib/authRouting";

/** Hidden top-left trigger — 10 clicks opens admin login. */
export function AdminPortalEasterEgg() {
    const navigate = useNavigate();
    const clicks = useRef(0);
    const resetTimer = useRef(null);

    const handleClick = () => {
        clicks.current += 1;
        if (resetTimer.current) clearTimeout(resetTimer.current);
        resetTimer.current = setTimeout(() => {
            clicks.current = 0;
        }, 4000);
        if (clicks.current >= 10) {
            clicks.current = 0;
            navigate(ADMIN_LOGIN);
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-hidden
            tabIndex={-1}
            className="admin-portal-easter-egg"
            data-testid="admin-portal-easter-egg"
        />
    );
}
